import { createTheme, MantineColorsTuple } from '@mantine/core';

// Haive brand colors (orange from logo -- glows against dark backgrounds)
const haiveOrange: MantineColorsTuple = [
  '#fff4e6',
  '#ffe8cc',
  '#ffd8a8',
  '#ffc078',
  '#ffa94d',
  '#ff922b',
  '#fd7e14', // Primary
  '#f76707',
  '#e8590c',
  '#d9480f',
];

// Navy blue from logo -- used for depth layers
const haiveNavy: MantineColorsTuple = [
  '#e7f5ff',
  '#d0ebff',
  '#a5d8ff',
  '#74c0fc',
  '#4dabf7',
  '#339af0',
  '#228be6',
  '#1c7ed6',
  '#1971c2',
  '#1a365d', // Logo navy
];

export const theme = createTheme({
  primaryColor: 'haiveOrange',
  colors: {
    haiveOrange,
    haiveNavy,
    dark: [
      '#C1C2C5',
      '#A6A7AB',
      '#909296',
      '#5C5F66',
      '#373A40',
      '#2C2E33',
      '#25262B',
      '#1A1B1E',
      '#141517',
      '#101113',
    ],
  },
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  headings: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: '700',
  },
  defaultRadius: 'lg',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: {
        radius: 'xl', // Pill-shaped buttons
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
      },
      styles: {
        root: {
          background: 'rgba(255, 255, 255, 0.03)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
        },
      },
    },
    Paper: {
      styles: {
        root: {
          background: 'rgba(255, 255, 255, 0.04)',
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        },
      },
    },
    Notification: {
      styles: {
        root: {
          background: 'rgba(20, 20, 22, .92)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255, 255, 255, .08)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, .4)',
        },
        title: {
          color: '#fff',
          fontWeight: 600,
          fontSize: 13,
        },
        description: {
          color: 'rgba(255, 255, 255, .5)',
          fontSize: 12,
        },
        icon: {
          background: 'transparent',
        },
        closeButton: {
          color: 'rgba(255, 255, 255, .35)',
        },
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Textarea: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Select: {
      defaultProps: {
        radius: 'lg',
      },
    },
  },
});
